export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    // Modern way - requires HTTPS or localhost
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers or non-secure contexts
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      let successful = false;
      try {
        successful = document.execCommand('copy');
      } catch (err) {
        console.error('Fallback copy failed:', err);
      }
      
      document.body.removeChild(textArea);
      return successful;
    }
  } catch (error) {
    console.error('Error copying to clipboard:', error);
    return false;
  }
};

export const formatClipsForCopy = (clips: Array<{ title: string; content: string }>): string => {
  return clips
    .map((clip) => `=== ${clip.title} ===\n${clip.content}\n`)
    .join('\n');
};
